import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Offcanvas, Image } from "react-bootstrap";
import UpjLogoAdm from "../../assets/upj-logo.svg";
import "../styles/offcanvas.css";

const OffcanvasMenu = ({ show, handleClose }) => {
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="start"
      id="offcanvas-container-admin"
    >
      <Offcanvas.Header closeButton className="d-flex align-items-center gap-2 pb-2 mx-2 mt-2">
        <Image src={UpjLogoAdm} width={40} />
        <Offcanvas.Title>Hello HRD UPJ</Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="text-white fw-bold w-100" />
      <Offcanvas.Body className="p-0">
        <div className="list-group-offcanvas d-flex flex-column align-items-start  gap-3">
          <NavLink
            to="dashboard"
            className={({ isActive }) =>
              isActive
                ? "list-group-offcanvas-item active"
                : "list-group-offcanvas-item"
            }
            onMouseEnter={() => handleMouseEnter("dashboard")}
            onMouseLeave={handleMouseLeave}
            onClick={handleClose}
          >
            {({ isActive }) => (
              <>
                <i
                  className={`bi ${
                    isActive || hoveredItem === "dashboard"
                      ? "bi-house-fill"
                      : "bi-house"
                  } fs-5 me-2`}
                ></i>
                <span className="fs-6">Dashboard</span>
              </>
            )}
          </NavLink>
          <NavLink
            to="manageUser"
            className={({ isActive }) =>
              isActive
                ? "list-group-offcanvas-item active"
                : "list-group-offcanvas-item"
            }
            onMouseEnter={() => handleMouseEnter("manageUser")}
            onMouseLeave={handleMouseLeave}
            onClick={handleClose}
          >
            {({ isActive }) => (
              <>
                <i
                  className={`bi ${
                    isActive || hoveredItem === "manageUser"
                      ? "bi-person-fill"
                      : "bi-person"
                  } fs-5 me-2`}
                ></i>
                <span className="fs-6">Manage User</span>
              </>
            )}
          </NavLink>
          <NavLink
            to="resultPsikotesUser"
            className={({ isActive }) =>
              isActive
                ? "list-group-offcanvas-item active"
                : "list-group-offcanvas-item"
            }
            onMouseEnter={() => handleMouseEnter("resultPsikotesUser")}
            onMouseLeave={handleMouseLeave}
            onClick={handleClose}
          >
            {({ isActive }) => (
              <>
                <i
                  className={`bi ${
                    isActive || hoveredItem === "resultPsikotesUser"
                      ? "bi-bar-chart-fill"
                      : "bi-bar-chart"
                  } fs-5 me-2`}
                ></i>
                <span className="fs-6">Psikotes Results</span>
              </>
            )}
          </NavLink>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default OffcanvasMenu;
